import React, { useRef, useState } from "react";
import "../Styles/VideoAndDocumentsUploader.css";

const VideoAndDocumentsUploader = ({
  videoFile,
  setVideoFile,
  communitieDocs,
  docFile,
  setDocFile,
  docName,
  setDocName,
  selectedReligion,
}) => {
  const videoInputRef = useRef(null);
  const docInputRef = useRef(null);

  // ===== VIDEO HANDLERS =====
  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideoFile(file);
    }
  };

  const removeVideo = () => {
    setVideoFile(null);
    if (videoInputRef.current) {
      videoInputRef.current.value = "";
    }
  };

  return (
    <div className="Uploader-container">
      {/* ================= INTRODUCTION VIDEO ================= */}
      <div className="Uploader-section">
        <h3 className="Uploader-heading">Introduction Video</h3>
        <p className="Uploader-subheading">Optional</p>

        <div
          className="Uploader-video-box"
          onClick={() => {
            // ✅ open file picker ONLY if no video
            if (!videoFile && videoInputRef.current) {
              videoInputRef.current.click();
            }
          }}
        >
          {videoFile ? (
            <div className="Uploader-video-wrapper">
              <button
                className="Uploader-video-remove"
                onClick={(e) => {
                  e.stopPropagation(); // 🔥 prevent opening picker
                  removeVideo();
                }}
              >
                ✕
              </button>

              <video width="50%" height="200px" controls>
                <source src={URL.createObjectURL(videoFile)} />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <>
              <div className="Uploader-icon">&#8679;</div>
              <p className="Uploader-upload-text">Upload Video</p>
            </>
          )}

          <input
            type="file"
            accept="video/*"
            ref={videoInputRef}
            hidden
            onChange={handleVideoUpload}
          />
        </div>
      </div>

      {/* ================= DOCUMENTS ================= */}
      <div className="Uploader-section">
        <h3 className="Uploader-heading">Others</h3>
        <p className="Uploader-subtext">
          Upload other relevant documents (e.g., Kundali, Baptism Certificate,
          etc.) as per your community.
        </p>

        <div className="Uploader-doc-box">
          {/* ===== Document Type Dropdown ===== */}
          <select
            className="Uploader-dropdown"
            value={docName}
            onChange={(e) => setDocName(e.target.value)}
          >
            <option value="">Select Document Type</option>

            {communitieDocs
              ?.filter((item) => item.ReligionId === (selectedReligion || 1))
              .map((item) => (
                <option key={item.id} value={item.DocName}>
                  {item.DocName}
                </option>
              ))}
          </select>

          <div className="Uploader-upload-area">
            {/* ==== Top Right Icons ==== */}
            {docFile && (
              <div className="Uploader-doc-actions">
                {/* 👁 VIEW */}
                {docFile.url && (
                  <button
                    className="Uploader-doc-view"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(docFile.url, "_blank");
                    }}
                  >
                    👁
                  </button>
                )}

                {/* ❌ REMOVE */}
              {docFile &&  <button
                  className="Uploader-doc-remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDocFile(null);
                  }}
                >
                  ✕
                </button> }
              </div>
            )}

            {/* ==== Upload Area ==== */}
            <div
              onClick={() => {
                if (!docName) {
                  alert("Select Document type");
                  return;
                }
                docInputRef.current.click();
              }}
            >
              {docFile ? (
                <span>{docFile.name}</span>
              ) : (
                <>
                  <span className="Uploader-upload-icon">&#128228;</span>
                  <span>Upload Document</span>
                  <small>Accepted formats: PDF, JPEG, PNG</small>
                </>
              )}
            </div>

            <input
              type="file"
              hidden
              ref={docInputRef}
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => {
                if (!docName) {
                  alert("Select Document type");
                  return;
                }

                setDocFile({
                  name: docName,
                  file: e.target.files[0],
                  url: URL.createObjectURL(e.target.files[0]),
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoAndDocumentsUploader;
